package com.ijoin.platform.shortcut

/**
 * Shared metadata for creating a shortcut that deep links into a user profile.
 */
data class ProfileShortcutInfo(
    val userId: String,
    val displayName: String,
    val username: String,
    val avatarUrl: String?
)

object ProfileShortcutConstants {
    const val EXTRA_USER_ID = "com.ijoin.extra.USER_ID"
    const val EXTRA_DISPLAY_NAME = "com.ijoin.extra.DISPLAY_NAME"
    const val EXTRA_USERNAME = "com.ijoin.extra.USERNAME"
    const val EXTRA_AVATAR_URL = "com.ijoin.extra.AVATAR_URL"
    const val SHORTCUT_PREFIX = "user_profile_"
}

expect object ProfileShortcutManager {
    fun isSupported(): Boolean
    fun requestAddShortcut(info: ProfileShortcutInfo): Boolean
}
